// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';

// custom pages
import Context from "context/context";
import Table from "components/Table/Table";
import useDebounce from "helpers/useDebounce";
// import "./Privilege.css";
 import { Styles } from "./styles";
import privilegeApi from "apis/privilege/privilege";
import Loader from "components/Loader/Loader";
import searchIcon from "assets/img/Search_Icon.png";
//US
import Gold from "assets/img/Gold_wword_Gold.png";
import Silver from "assets/img/Silver_wword_Silver.png";
import Platinum from "assets/img/Platinum_wword_Platinum.png";
import Bronze from "assets/img/BronzeFuschia_wwords_Bronze.png";
// Canada
import GoldCA from 'assets/img/gold-level.png';
import SilverCA from 'assets/img/silver-level.png';
import PlatinumCA from 'assets/img/platinum-level.png';
import BronzeCA from 'assets/img/bronze-level.png';

import audit from "apis/audit/audit";
import access, { loyalty } from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";
import ManageSignatureAccountsAPI from "apis/manageSignatureAccounts/manageSignatureAccounts";
import AuditAPI from "apis/audit/audit";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

// material-ui icons
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";

//Helpers
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { dateFormat } from "helpers/dataFormat"
import { imageHandler } from 'helpers/imageHandler';
import { CSVLink } from 'react-csv';

// import { exportcontractHeaders } from "./export";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
        marginTop: 0,
      },
    },
  },
})(TextField);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ViewPlan(props) {
  const { state, dispatch } = useContext(Context);
  const { getviewplan } = ManageSignatureAccountsAPI();
  const { getCustomAuditAPI } = AuditAPI();
  

  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const [customerData, setCustomerData] = useState([]);
  const [customerDataClone, setCustomerDataClone] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const classes = Styles();
  const [fillter, setfillter] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [loyaltyAccount, setLoyaltyAccount] = useState(
    location?.state?.data || []
  );
  const [response, setResponse] = useState(false);
  const [privilegeCodes, setPrivilegeCodes] = useState({});
  const [privilegeCodesArray, setPrivilegeCodesArray] = useState({});
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [privilege_flag, setPrivilege_flag] = useState(false)
  const [exportData, setExportData] = useState([]);
  const [IsLoading, setIsLoading] = useState();
   const [viewplan, setviewplan] = useState(
    []
  );

  const [states, setstates] = useState({
    historyDialog: false,
    historyData: [],
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const handlePagination = (value) => {
    setOffset(value);
  };

  const toastCss = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  };


   useEffect(() => {
      if (location?.state?.Id) {
        handleGetviewplan();
        handleGetHistoryData();

        return;
      }
      history.goBack();
    }, []);


   let id = location?.state?.Id;
   let shiptoId = location?.state?.shipto;
  

   const handleGetviewplan = async () => {
    try {
      let values;
      values = {
        recordId: id,
        
      };
      let res = await getviewplan(values);
      if (res) {
        setviewplan(res?.data[0]);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleGetHistoryData = async () => {
    try {
      let values;
      values = {
        recordId: id,
        feature: "manageSignatureAccounts",
      };
      let res = await getCustomAuditAPI(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };
  

  return (
    <React.Fragment>
      <Grid
        style={{
          width: "100%",
          height: 50,
          backgroundColor: "#2F7CBD",
          marginBottom: 10,
        }}
      >
        <Grid
          xs={12}
          sm={12}
          lg={12}
          style={{
            color: "#fff",
            fontSize: 22,
            display: "flex",
            alignItems: "center",
          }}
        >
          <ArrowBackOutlinedIcon
            style={{
              fontSize: 22,
              margin: "10px 10px 10px 10px",
              cursor: "pointer",
            }}
            onClick={() => {
              history.push({
                pathname: "/dashboard/manage-signature-accounts",
                searchValue: location?.state?.search,
              });
            }}
          />
          <span>{t('Signature Plan Change History')}</span>
        </Grid>
      </Grid>
      <div className="container">
        <Grid container spacing={0} style={{ margin: "10px 10px 10px 10px" }}>
          <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>{t('Shipto Id')} </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {shiptoId}
              </div>
            </div>
          </Grid>
                  <Grid xs={6} sm={3} lg={3}>
          <div className={classes.gridDiv}>
            <div style={{ color: "#707070", fontSize: 14 }}>
              {t("Old Plan")}{" "}
            </div>

            <div style={{ color: "#000000", fontSize: 16 }}>
              {viewplan?.old_value === "ST0"
                ? "Signature Monthly"
                : viewplan?.old_value === "ST1"
                ? "Signature Yearly"
                : viewplan?.old_value === "ST2"
                ? "Signature Trial"
                 : viewplan?.old_value === "ST3"
                ? "Startup"
                : viewplan?.old_value || "-"}
            </div>
          </div>
        </Grid>
          <Grid xs={6} sm={3} lg={3}>
  <div className={classes.gridDiv}>
    <div style={{ color: "#707070", fontSize: 14 }}>
      {t("New Plan")}{" "}
    </div>

    <div style={{ color: "#000000", fontSize: 16 }}>
      {viewplan?.new_value === "ST0"
        ? "Signature Monthly"
        : viewplan?.new_value === "ST1"
        ? "Signature Yearly"
        : viewplan?.new_value === "ST2"
        ? "Signature Trial"
        : viewplan?.old_value === "ST3"
        ? "Startup"
        : viewplan?.new_value || "-"}
    </div>
  </div>
</Grid>

             <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>{t('Updated By')} </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
                {viewplan?.email || "System"}
              </div>
            </div>
            </Grid>

             <Grid xs={6} sm={3} lg={3}>
            <div className={classes.gridDiv}>
              <div style={{ color: "#707070", fontSize: 14 }}>{t('Updated On')} </div>
              <div style={{ color: "#000000", fontSize: 16 }}>
               {moment(viewplan?.updated_at).format("MMM-DD-YYYY")||"-"}
              </div>
            </div>
          </Grid>
          
         
          
          
          
        </Grid>
        <br />
      
      <div style={{ marginTop: 26 }}>
  {!historyLoader ? (
    <div
      style={{
        maxHeight: "500px",
        overflowY: "auto",
        overflowX: "auto",
      }}
    >
      <HistoryTable
        headings={[
          "Date of Change",
          "Updated by",
          "Setting",
          "Description",
          "Reason",
        ]}
        data={
          states?.historyData?.length > 0
            ? states?.historyData.map((d, i) => [
                d?.created_at
                  ? moment(d?.created_at).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  : "",

                d?.["User.email"]
                  ? d?.["User.email"]
                  : d?.altered_by
                  ? d?.altered_by.charAt(0).toUpperCase() +
                    d?.altered_by.slice(1).toLowerCase()
                  : "-",

                d?.column_name,

                `"${!d?.old_value
                  ? "not set"
                  : moment(
                      d?.old_value,
                      [
                        "YYYY-MM-DD",
                        "YYYY-MM-DD HH:mm:ss",
                        "ddd MMM DD YYYY HH:mm:ss [GMT]Z",
                      ],
                      true
                    ).isValid()
                  ? moment(d?.old_value).format("MMM DD YYYY")
                  : d?.old_value
                }" changed to "${!d?.new_value
                  ? "not set"
                  : moment(
                      d?.new_value,
                      [
                        "YYYY-MM-DD",
                        "YYYY-MM-DD HH:mm:ss",
                        "ddd MMM DD YYYY HH:mm:ss [GMT]Z",
                      ],
                      true
                    ).isValid()
                  ? moment(d?.new_value).format("MMM DD YYYY")
                  : d?.new_value
                }"`,

                d?.reason,
              ])
            : []
        }
        disablePagination={true}
      />
    </div>
  ) : (
    <div>
      <Loader Loading={historyLoader} top={"15%"} />
    </div>
  )}
</div>
      </div>

     
      {/* history */}
     
    </React.Fragment>
  );
}
